var _ellipse, _ellipse2, _ellipse3, _g, _g2, _g3, _path, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerificationIntroDesk = function SvgVerificationIntroDesk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 845,
    height: 710,
    viewBox: "0 0 845 710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    rx: 422.388,
    ry: 355,
    transform: "matrix(-1 0 0 1 422.388 355)",
    fill: "url(#paint0_linear_4760_11317)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    rx: 301.706,
    ry: 254.138,
    transform: "matrix(-1 0 0 1 422.388 354.56)",
    fill: "url(#paint1_linear_4760_11317)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    rx: 187.04,
    ry: 157.117,
    transform: "matrix(-1 0 0 1 420.195 355.117)",
    fill: "url(#paint2_linear_4760_11317)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4760_11317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.152 221.081C578.277 221.877 579.726 222.076 581.017 221.587C582.309 221.095 583.259 219.991 583.545 218.654C586.579 204.395 593.939 168.304 596.701 155.334C596.91 154.356 596.561 153.34 595.793 152.687C595.025 152.034 593.96 151.846 593.01 152.199C578.371 157.617 533.286 174.533 514.859 181.352C513.689 181.785 512.928 182.909 512.966 184.141C513.008 185.377 513.839 186.449 515.037 186.809C523.301 189.281 534.149 192.72 534.149 192.72C534.149 192.72 539.218 208.03 541.861 215.816C542.193 216.793 542.957 217.561 543.967 217.827C544.972 218.089 546.047 217.813 546.798 217.104C551.044 213.096 557.607 206.899 557.607 206.899C557.607 206.899 570.079 216.043 577.152 221.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.152 221.081C578.277 221.877 579.726 222.076 581.017 221.587C582.309 221.095 583.259 219.991 583.545 218.654C586.579 204.395 593.939 168.304 596.701 155.334C596.91 154.356 596.561 153.34 595.793 152.687C595.025 152.034 593.96 151.846 593.01 152.199C578.371 157.617 533.286 174.533 514.859 181.352C513.689 181.785 512.928 182.909 512.966 184.141C513.008 185.377 513.839 186.449 515.037 186.809C523.301 189.281 534.149 192.72 534.149 192.72C534.149 192.72 539.218 208.03 541.861 215.816C542.193 216.793 542.957 217.561 543.967 217.827C544.972 218.089 546.047 217.813 546.798 217.104C551.044 213.096 557.607 206.899 557.607 206.899C557.607 206.899 570.079 216.043 577.152 221.081ZM538.712 190.786L544.574 210.121L545.876 197.877C545.876 197.877 568.525 177.448 581.436 165.805C581.813 165.462 581.866 164.89 581.552 164.488C581.241 164.087 580.668 163.993 580.239 164.265C565.275 173.821 538.712 190.786 538.712 190.786Z",
    fill: "url(#paint3_linear_4760_11317)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4760_11317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.718 441.633C251.577 441.633 235.245 457.965 235.245 478.106C235.245 495.005 246.754 509.189 262.357 513.322L271.718 522.683L281.079 513.322C296.681 509.189 308.191 495.005 308.191 478.106C308.191 457.965 291.859 441.633 271.718 441.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.718 441.633C251.577 441.633 235.245 457.965 235.245 478.106C235.245 495.005 246.754 509.189 262.357 513.322L271.718 522.683L281.079 513.322C296.681 509.189 308.191 495.005 308.191 478.106C308.191 457.965 291.859 441.633 271.718 441.633ZM271.718 449.738C278.445 449.738 283.875 455.168 283.875 461.895C283.875 468.623 278.445 474.053 271.718 474.053C264.991 474.053 259.56 468.623 259.56 461.895C259.56 455.168 264.991 449.738 271.718 449.738ZM271.718 507.689C261.587 507.689 252.63 502.502 247.403 494.64C247.524 486.575 263.613 482.158 271.718 482.158C279.782 482.158 295.912 486.575 296.033 494.64C290.805 502.502 281.849 507.689 271.718 507.689Z",
    fill: "url(#paint4_linear_4760_11317)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4760_11317)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 112.224,
    ry: 93.522,
    transform: "matrix(-1 0 0 1 420.196 336.417)",
    fill: "url(#paint5_linear_4760_11317)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.472 336.417C308.472 387.71 358.403 429.439 420.196 429.439C481.989 429.439 531.92 387.71 531.92 336.417C531.92 285.123 481.989 243.395 420.196 243.395C358.403 243.395 308.472 285.123 308.472 336.417Z",
    stroke: "url(#paint6_radial_4760_11317)",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M508.867 248.726C509.502 248.194 509.586 247.248 509.055 246.613C508.523 245.978 507.577 245.894 506.942 246.425L508.867 248.726ZM487.48 317.557L486.302 316.628L487.48 317.557ZM367.484 339.625L368.476 340.751L368.476 340.751L367.484 339.625ZM326.446 441.23C326.446 442.059 327.117 442.73 327.946 442.73C328.774 442.73 329.446 442.059 329.446 441.23H326.446ZM504.726 248.349C504.111 248.903 504.061 249.852 504.615 250.467C505.17 251.083 506.118 251.132 506.734 250.578L504.726 248.349ZM501.393 255.865C501.954 255.256 501.915 254.307 501.305 253.746C500.696 253.185 499.747 253.224 499.186 253.834L501.393 255.865ZM495.375 258.266C494.857 258.912 494.96 259.856 495.605 260.375C496.251 260.894 497.195 260.791 497.714 260.145L495.375 258.266ZM493.256 266.213C493.718 265.525 493.534 264.593 492.847 264.131C492.159 263.669 491.227 263.853 490.765 264.54L493.256 266.213ZM487.663 269.482C487.244 270.197 487.484 271.116 488.199 271.535C488.914 271.954 489.833 271.714 490.251 270.999L487.663 269.482ZM486.7 277.653C487.061 276.907 486.749 276.01 486.004 275.649C485.258 275.288 484.361 275.6 484 276.345L486.7 277.653ZM481.617 281.658C481.3 282.424 481.664 283.301 482.429 283.618C483.195 283.934 484.072 283.571 484.389 282.805L481.617 281.658ZM481.782 289.88C482.037 289.092 481.605 288.246 480.817 287.991C480.029 287.736 479.183 288.168 478.928 288.956L481.782 289.88ZM477.3 294.576C477.095 295.379 477.58 296.195 478.382 296.4C479.185 296.605 480.002 296.121 480.207 295.318L477.3 294.576ZM478.691 302.659C478.818 301.841 478.257 301.074 477.439 300.947C476.62 300.82 475.854 301.381 475.727 302.2L478.691 302.659ZM475.085 308.049C475.036 308.876 475.666 309.587 476.493 309.637C477.32 309.686 478.03 309.056 478.08 308.229L475.085 308.049ZM478.325 315.561C478.193 314.744 477.423 314.188 476.605 314.32C475.788 314.452 475.232 315.222 475.364 316.039L478.325 315.561ZM477.832 322.089C478.4 322.692 479.35 322.72 479.953 322.152C480.556 321.584 480.584 320.635 480.016 320.032L477.832 322.089ZM484.5 318.656C483.907 319.234 483.894 320.184 484.472 320.777C485.05 321.371 486 321.383 486.593 320.805L484.5 318.656ZM490.539 315.8C490.968 315.091 490.741 314.169 490.033 313.74C489.324 313.311 488.402 313.538 487.973 314.247L490.539 315.8ZM489.024 308.084C489.447 308.796 490.368 309.03 491.08 308.606C491.792 308.182 492.025 307.262 491.602 306.55L489.024 308.084ZM485.828 302.528C485.041 302.271 484.194 302.701 483.937 303.489C483.68 304.276 484.11 305.123 484.897 305.38L485.828 302.528ZM477.189 304.149C478.017 304.193 478.722 303.557 478.766 302.73C478.809 301.903 478.174 301.197 477.347 301.153L477.189 304.149ZM471.099 301.122C470.271 301.152 469.624 301.847 469.654 302.675C469.683 303.503 470.378 304.15 471.206 304.12L471.099 301.122ZM463.153 304.73C463.976 304.639 464.57 303.898 464.479 303.074C464.388 302.251 463.647 301.657 462.823 301.748L463.153 304.73ZM456.668 302.559C455.849 302.683 455.286 303.448 455.41 304.267C455.534 305.086 456.299 305.649 457.118 305.525L456.668 302.559ZM449.108 306.924C449.921 306.764 450.45 305.976 450.291 305.163C450.131 304.35 449.343 303.821 448.53 303.98L449.108 306.924ZM442.482 305.257C441.674 305.439 441.167 306.242 441.349 307.05C441.531 307.858 442.334 308.366 443.142 308.183L442.482 305.257ZM435.233 310.11C436.035 309.901 436.515 309.081 436.305 308.279C436.096 307.478 435.276 306.998 434.475 307.207L435.233 310.11ZM428.515 308.842C427.719 309.07 427.259 309.901 427.488 310.697C427.716 311.494 428.547 311.954 429.343 311.725L428.515 308.842ZM421.551 314.096C422.34 313.842 422.774 312.997 422.52 312.208C422.267 311.42 421.422 310.986 420.633 311.24L421.551 314.096ZM414.775 313.2C413.993 313.473 413.58 314.328 413.852 315.11C414.124 315.892 414.979 316.306 415.762 316.033L414.775 313.2ZM408.119 318.837C408.892 318.539 409.276 317.67 408.978 316.897C408.679 316.125 407.811 315.74 407.038 316.039L408.119 318.837ZM401.299 318.344C400.535 318.664 400.174 319.542 400.494 320.307C400.813 321.071 401.692 321.432 402.456 321.112L401.299 318.344ZM395.029 324.39C395.779 324.04 396.104 323.147 395.754 322.397C395.404 321.646 394.511 321.321 393.761 321.671L395.029 324.39ZM388.198 324.382C387.46 324.759 387.167 325.662 387.543 326.4C387.919 327.138 388.823 327.431 389.561 327.055L388.198 324.382ZM382.425 330.941C383.141 330.524 383.382 329.605 382.965 328.89C382.547 328.174 381.629 327.932 380.913 328.35L382.425 330.941ZM375.623 331.621C374.931 332.076 374.739 333.006 375.194 333.698C375.648 334.39 376.579 334.583 377.271 334.128L375.623 331.621ZM370.751 338.841C371.397 338.322 371.5 337.378 370.982 336.732C370.463 336.086 369.519 335.982 368.873 336.501L370.751 338.841ZM364.229 340.556C363.624 341.123 363.593 342.072 364.159 342.677C364.726 343.281 365.675 343.312 366.279 342.746L364.229 340.556ZM360.737 348.375C361.294 347.762 361.248 346.813 360.635 346.256C360.022 345.699 359.073 345.745 358.516 346.358L360.737 348.375ZM354.546 350.998C354.026 351.643 354.128 352.588 354.773 353.107C355.418 353.627 356.362 353.525 356.882 352.88L354.546 350.998ZM352.162 359.224C352.631 358.541 352.458 357.608 351.775 357.139C351.092 356.67 350.158 356.843 349.689 357.526L352.162 359.224ZM346.379 362.647C345.948 363.355 346.173 364.278 346.88 364.708C347.588 365.139 348.511 364.914 348.942 364.206L346.379 362.647ZM345.068 371.113C345.448 370.377 345.159 369.472 344.423 369.092C343.687 368.712 342.782 369 342.402 369.736L345.068 371.113ZM339.744 375.217C339.401 375.971 339.734 376.861 340.488 377.204C341.242 377.547 342.132 377.213 342.475 376.459L339.744 375.217ZM339.421 383.777C339.717 383.003 339.328 382.136 338.554 381.841C337.78 381.545 336.914 381.934 336.618 382.708L339.421 383.777ZM334.577 388.44C334.316 389.226 334.742 390.075 335.528 390.336C336.315 390.597 337.163 390.171 337.424 389.384L334.577 388.44ZM335.138 396.986C335.355 396.186 334.882 395.362 334.083 395.146C333.283 394.929 332.459 395.401 332.242 396.201L335.138 396.986ZM330.768 402.099C330.583 402.906 331.087 403.711 331.895 403.896C332.702 404.081 333.507 403.577 333.692 402.769L330.768 402.099ZM332.111 410.557C332.256 409.742 331.712 408.963 330.896 408.818C330.08 408.674 329.302 409.217 329.157 410.033L332.111 410.557ZM328.203 416.03C328.087 416.85 328.658 417.609 329.478 417.724C330.299 417.84 331.058 417.269 331.173 416.449L328.203 416.03ZM330.243 424.353C330.321 423.528 329.716 422.796 328.891 422.718C328.067 422.64 327.335 423.245 327.257 424.07L330.243 424.353ZM326.786 430.119C326.735 430.946 327.365 431.657 328.192 431.708C329.018 431.758 329.73 431.129 329.78 430.302L326.786 430.119ZM329.471 438.249C329.485 437.42 328.825 436.738 327.996 436.724C327.168 436.71 326.485 437.37 326.471 438.198L329.471 438.249ZM506.942 246.425C506.188 247.056 505.45 247.697 504.726 248.349L506.734 250.578C507.431 249.95 508.142 249.333 508.867 248.726L506.942 246.425ZM499.186 253.834C497.855 255.28 496.585 256.76 495.375 258.266L497.714 260.145C498.883 258.69 500.109 257.261 501.393 255.865L499.186 253.834ZM490.765 264.54C489.669 266.173 488.635 267.823 487.663 269.482L490.251 270.999C491.194 269.391 492.194 267.793 493.256 266.213L490.765 264.54ZM484 276.345C483.14 278.122 482.346 279.896 481.617 281.658L484.389 282.805C485.096 281.097 485.866 279.376 486.7 277.653L484 276.345ZM478.928 288.956C478.31 290.866 477.768 292.744 477.3 294.576L480.207 295.318C480.659 293.548 481.183 291.731 481.782 289.88L478.928 288.956ZM475.727 302.2C475.408 304.256 475.196 306.215 475.085 308.049L478.08 308.229C478.184 306.496 478.386 304.631 478.691 302.659L475.727 302.2ZM475.364 316.039C475.768 318.544 476.536 320.712 477.832 322.089L480.016 320.032C479.336 319.31 478.696 317.86 478.325 315.561L475.364 316.039ZM486.593 320.805C487.266 320.15 487.954 319.378 488.657 318.487L486.302 316.628C485.664 317.436 485.063 318.108 484.5 318.656L486.593 320.805ZM488.657 318.487C489.39 317.559 490.017 316.663 490.539 315.8L487.973 314.247C487.525 314.988 486.971 315.781 486.302 316.628L488.657 318.487ZM491.602 306.55C490.457 304.626 488.36 303.355 485.828 302.528L484.897 305.38C487.11 306.102 488.41 307.053 489.024 308.084L491.602 306.55ZM477.347 301.153C475.408 301.051 473.317 301.043 471.099 301.122L471.206 304.12C473.352 304.044 475.353 304.053 477.189 304.149L477.347 301.153ZM462.823 301.748C460.835 301.968 458.779 302.239 456.668 302.559L457.118 305.525C459.192 305.21 461.207 304.945 463.153 304.73L462.823 301.748ZM448.53 303.98C446.544 304.37 444.526 304.796 442.482 305.257L443.142 308.183C445.159 307.729 447.151 307.308 449.108 306.924L448.53 303.98ZM434.475 307.207C432.499 307.724 430.51 308.269 428.515 308.842L429.343 311.725C431.315 311.159 433.281 310.62 435.233 310.11L434.475 307.207ZM420.633 311.24C418.676 311.869 416.721 312.523 414.775 313.2L415.762 316.033C417.684 315.364 419.616 314.718 421.551 314.096L420.633 311.24ZM407.038 316.039C405.105 316.785 403.189 317.554 401.299 318.344L402.456 321.112C404.32 320.333 406.21 319.574 408.119 318.837L407.038 316.039ZM393.761 321.671C391.867 322.554 390.01 323.459 388.198 324.382L389.561 327.055C391.34 326.148 393.165 325.259 395.029 324.39L393.761 321.671ZM380.913 328.35C379.081 329.419 377.314 330.51 375.623 331.621L377.271 334.128C378.913 333.049 380.634 331.986 382.425 330.941L380.913 328.35ZM368.873 336.501C368.05 337.161 367.256 337.828 366.493 338.5L368.476 340.751C369.203 340.111 369.961 339.474 370.751 338.841L368.873 336.501ZM366.493 338.5C365.724 339.177 364.97 339.862 364.229 340.556L366.279 342.746C366.998 342.073 367.73 341.408 368.476 340.751L366.493 338.5ZM358.516 346.358C357.138 347.875 355.815 349.423 354.546 350.998L356.882 352.88C358.115 351.35 359.399 349.848 360.737 348.375L358.516 346.358ZM349.689 357.526C348.533 359.211 347.43 360.919 346.379 362.647L348.942 364.206C349.965 362.524 351.038 360.862 352.162 359.224L349.689 357.526ZM342.402 369.736C341.466 371.549 340.581 373.377 339.744 375.217L342.475 376.459C343.292 374.663 344.155 372.88 345.068 371.113L342.402 369.736ZM336.618 382.708C335.892 384.613 335.212 386.525 334.577 388.44L337.424 389.384C338.046 387.51 338.711 385.64 339.421 383.777L336.618 382.708ZM332.242 396.201C331.708 398.171 331.218 400.139 330.768 402.099L333.692 402.769C334.133 400.847 334.614 398.917 335.138 396.986L332.242 396.201ZM329.157 410.033C328.799 412.048 328.482 414.049 328.203 416.03L331.173 416.449C331.448 414.502 331.759 412.537 332.111 410.557L329.157 410.033ZM327.257 424.07C327.063 426.119 326.907 428.137 326.786 430.119L329.78 430.302C329.899 428.353 330.052 426.367 330.243 424.353L327.257 424.07ZM326.471 438.198C326.454 439.223 326.446 440.234 326.446 441.23H329.446C329.446 440.251 329.454 439.256 329.471 438.249L326.471 438.198Z",
    fill: "#C9CBC3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4760_11317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.335,
    y: 280.738,
    width: 65.9558,
    height: 65.9558,
    rx: 32.9779,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.335,
    y: 280.738,
    width: 65.9558,
    height: 65.9558,
    rx: 32.9779,
    fill: "#587300",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.313 297.065V290.82L414.987 299.146L423.313 307.472V301.228C430.203 301.228 435.802 306.827 435.802 313.717C435.802 315.819 435.282 317.817 434.345 319.545L437.384 322.584C439.007 320.024 439.965 316.985 439.965 313.717C439.965 304.517 432.513 297.065 423.313 297.065ZM423.313 326.206C416.423 326.206 410.824 320.606 410.824 313.717C410.824 311.614 411.344 309.616 412.281 307.889L409.242 304.85C407.619 307.41 406.661 310.449 406.661 313.717C406.661 322.917 414.113 330.369 423.313 330.369V336.613L431.639 328.287L423.313 319.961V326.206Z",
    fill: "#314000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.335,
    y: 278.738,
    width: 69.9558,
    height: 69.9558,
    rx: 34.9779,
    stroke: "white",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4760_11317",
    x: 468.491,
    y: 134.566,
    width: 212.742,
    height: 218.742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20,
    dy: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4760_11317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4760_11317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4760_11317",
    x: 203.088,
    y: 433.527,
    width: 137.261,
    height: 149.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4760_11317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4760_11317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4760_11317",
    x: 291.972,
    y: 242.895,
    width: 272.448,
    height: 235.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4760_11317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4760_11317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4760_11317",
    x: 370.335,
    y: 272.738,
    width: 121.956,
    height: 121.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4760_11317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4760_11317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4760_11317",
    x1: -67.1387,
    y1: 207.238,
    x2: 215.952,
    y2: 588.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4760_11317",
    x1: -47.9562,
    y1: 148.358,
    x2: 764.693,
    y2: 375.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4760_11317",
    x1: 92.3626,
    y1: 229.257,
    x2: 473.378,
    y2: 233.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4760_11317",
    x1: 596.761,
    y1: 186.937,
    x2: 543.614,
    y2: 69.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4760_11317",
    x1: 265.005,
    y1: 497.718,
    x2: 94.2016,
    y2: 288.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C9C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_11317",
    x1: 145.797,
    y1: 7.31992,
    x2: 113.03,
    y2: 187.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4760_11317",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.284 379.415) rotate(-144.583) scale(159.9 191.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161F00",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerificationIntroDesk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verification-intro-desk.0fda238.svg";